import { Link, useLocation } from 'react-router-dom'
import {
  LayoutDashboard,
  Users,
  PawPrint,
  CreditCard,
  FileText,
  Share2,
  MessageSquare,
  BarChart3,
  Users2,
  ShoppingCart,
  Stethoscope,
  Settings,
} from 'lucide-react'
import clsx from 'clsx'

/**
 * Sidebar Navigation Component
 * Displays main navigation links with active state styling
 */
const navItems = [
  { label: 'Dashboard', path: '/', icon: LayoutDashboard },
  { label: 'Users', path: '/users', icon: Users },
  { label: 'Pets', path: '/pets', icon: PawPrint },
  { label: 'Subscriptions', path: '/subscriptions', icon: CreditCard },
  { label: 'Content', path: '/content', icon: FileText },
  { label: 'Referrals', path: '/referrals', icon: Share2 },
  { label: 'Support', path: '/support', icon: MessageSquare },
  { label: 'Analytics', path: '/analytics', icon: BarChart3 },
  { label: 'Partners', path: '/partners', icon: Users2 },
  { label: 'Care Marketplace', path: '/care-marketplace', icon: ShoppingCart },
  { label: 'Vet Clinics', path: '/vet-clinics', icon: Stethoscope },
  { label: 'Settings', path: '/settings', icon: Settings },
]

export default function Sidebar() {
  const location = useLocation()

  return (
    <aside className="w-64 bg-white border-r border-pawssible-slate-200 shadow-sm h-screen flex flex-col overflow-y-auto">
      {/* Logo Section */}
      <div className="p-6 border-b border-pawssible-slate-200">
        <h1 className="text-2xl font-bold text-pawssible-teal-600">Pawssible Admin</h1>
        <p className="text-xs text-pawssible-slate-500 mt-1">Business Dashboard</p>
      </div>

      {/* Navigation Links */}
      <nav className="flex-1 p-4 space-y-2">
        {navItems.map((item) => {
          const Icon = item.icon
          const isActive = location.pathname === item.path
          return (
            <Link
              key={item.path}
              to={item.path}
              className={clsx(
                'flex items-center gap-3 px-4 py-2.5 rounded-lg transition-colors font-medium text-sm',
                isActive
                  ? 'bg-pawssible-teal-100 text-pawssible-teal-700'
                  : 'text-pawssible-slate-600 hover:bg-pawssible-slate-100'
              )}
            >
              <Icon size={20} />
              {item.label}
            </Link>
          )
        })}
      </nav>

      {/* Footer Section */}
      <div className="p-4 border-t border-pawssible-slate-200 space-y-2">
        <button className="w-full px-4 py-2 text-sm font-medium text-pawssible-slate-600 hover:bg-pawssible-slate-100 rounded-lg transition-colors">
          Profile
        </button>
        <button className="w-full px-4 py-2 text-sm font-medium text-red-600 hover:bg-red-50 rounded-lg transition-colors">
          Logout
        </button>
      </div>
    </aside>
  )
}
